"use client";

import { useMutation } from "@tanstack/react-query";
import { useAuth } from "@/state/globalStore";
import { resetPrintSettings } from "../api/resetPrintSettings";

export default function useResetPrintSettingsMutation() {
  const { accessToken } = useAuth();

  return useMutation({
    mutationFn: () => resetPrintSettings(accessToken),
  });
}
